import {useSelector} from "react-redux";
import {StoreI} from "~src/rootReducer";
import {CompanyI, Features} from "~src/interfaces/company.interface";

export function useCompany(): CompanyI|undefined {
  const company = useSelector((state: StoreI) => state.user.session.company);
  if (!company) {
    return undefined;
  }

  return company;
}


export function useFeatures(): Partial<Features> {
  const company = useCompany();
  if (!company) {
    return {};
  }
  return company.features
}
